<template>
    <b-container>

  <b-row>
    <b-col align="left" class="mt-2">
      <h1 class="font-weight-light text-center mb-2 mt-2">Privacy Policy</h1>
      <hr class="mt-3 mb-3">
    <h3>WHO ARE WE</h3>
      <p><b>Registered Company Name:</b> CloserStill Media Limited<br>
        <b>Trading As:</b> Cloud Expo Europe<br>
        <b>ICO Registration:</b> Z1479947<br>
    <br>
        <b>Registered Address:</b>
    <br>
    Suite 17 Exhibition House<br>
    Addison Bridge Place<br>
    London<br>
    W14 8XP<br><br>
        <b>Phone:</b> +44 (0)1923 692670<br>
    <b>E-Mail:</b> <a href="mailto:dataprotection@closerstillmedia.com?subject=">dataprotection@closerstillmedia.com</a><br></p>
    <h3>INFORMATION WE COLLECT</h3>
      <h5>Data submitted to us by the data subject, including:</h5>
      <li>Data submitted through our web forms from user registration</li>
      <h5>Data gathered by automated technologies / services, including:</h5>
      <li>Data gathered from services which use IP address to determine which organisation visitors to our site originate from</li>
      <li>Information from actions made by an individuals in response to direct marketing campaigns, including when an individual opens any emails or follows any links originating from our email communications</li>
      <li>Information related to website navigation, usage and engagement</li>
      <li>Data used to provide personalised marketing / user experiences while visiting our sites</li>
    <h3>INFORMATION WE MAY SHARE</h3>
      <h5>Transferring Personal Information Outside of the EEA</h5>
      <p>In processing your personal information, it will sometimes be necessary for us to transfer your personal information outside of the European Economic Area (“EEA”) to our group companies and our third party service providers.</p>
      <p>We will take all steps reasonably necessary to ensure that your personal information is treated securely and in accordance with this Policy and the data protection legislation when it is processed in, or otherwise accessed from, a location outside the EEA. In order to ensure this level of protection</p>
      <h5>When we will share your data with third parties</h5>
      <li>While using the site you may give consent to share data with specific third parties who may wish to communicate with you.</li>
      <li>If sharing is necessary for us to provide you with a service you have signed up for and is therefore a contractual obligation</li>
      <li>If we are under a duty to disclose or share your personal data in order to comply with any legal obligation</li>
      <li>We or substantially all of our assets are acquired by a third party, in which case personal data held by us about our customers will be one of the transferred assets</li>
      <li>You have consented to us sharing your details with carefully selected third parties whose products and services may interest you</li>
      <h5>How data is shared within CloserStill</h5>
      <p>Your information may be shared with divisions within the CloserStill Media group of companies (<a href="http://www.closerstillmedia.com/">list available here</a>).</p>
      <h3>SPECIAL CATEGORY DATA</h3>
      <p>“Special Category Data" is data which is deemed more sensitive under data protection regulations, and so needs more protection. Definitions available <a href="https://ico.org.uk/for-organisations/guide-to-data-protection/guide-to-the-general-data-protection-regulation-gdpr/lawful-basis-for-processing/special-category-data/">here.</a></p>
      <p>Although we generally seek to avoid collecting Special Category Data, there are some circumstances in which you may provide it to us (such as when you submit dietary requirements). In such cases, the provision of this information is entirely voluntary and subject to your express consent.</p>
      <p>Where we do receive Special Category Data, we will only keep such information for as long as necessary in order to fulfil the purpose for which it was provided and to comply with our obligations under the law.</p>

      <h3>HOW WE PROCESS YOUR INFORMATION</h3>
      <li>Provide you with information and updates relating to a service you have signed up to</li>
      <li>Ensure you can manage any service that you have signed up to</li>
      <li>Deliver targeted promotional messaging relating to our services</li>
      <li>Deliver targeted messaging relating to products and services of our affiliates (exhibitors, sponsors, media partners)</li>
      <li>Invite you to take surveys related to our products or the products or our affiliates</li>
      <li>Respond to you in relation to any enquiries you may have</li>
      <li>Produce analytics relating to your usage of our products and response to our marketing activities</li>

      <h3>YOUR RIGHTS</h3>
      <h5>Your rights under the GDPR include the following:</h5>
      <li>The right at any time to withdraw your consent to the processing of your personal data</li>
      <li>The right to make a subject access request to be informed of what personal data of yours we hold</li>
      <li>The right to have your personal data rectified in the event that it is inaccurate or incomplete</li>
      <li>The right to request the erasure of your personal data</li>
      <li>The right to object at any time to the processing of your personal data, especially where the processing is carried out for direct marketing purposes.</li>
      <li>The right to restrict the processing of your personal data</li>
      <li>The right to data portability (i.e. transfer of your personal data to another organisation)</li>
      <p>Your rights above can be exercised by contacting us at dataprotection@closerstillmedia.com and will be dealt with free of charge, we may require confirmation of your identity depending on your request.</p>
      <p>Should you have any queries or complaints in relation to how we use your personal information, please contact us at dataprotection@closerstillmedia.com. Should you wish to take any complaints or queries further, you have the right to contact the Information Commissioner's Office regarding such issues.</p>

      <h3>THIRD PARTY LINKS</h3>
      <p>Our website may, from time to time, contain links to and from third party websites. If you follow a link to any of these websites, please note that these websites have their own privacy policies and that we do not accept any responsibility or liability for these websites or their related policies. Please check these policies before you submit any personal information via these websites.</p>

      <h3>SECURITY</h3>
      <p>We take precautions to safeguard your personal information against loss, theft and misuse and unauthorised access, disclosure, alteration and destruction through the use of appropriate technical and organisational measures. Certain areas of our websites may be password protected. If you are a user of our websites and have a password, you can help to preserve your privacy by ensuring that you do not share your password with anyone else.</p>
      <p>We take steps to regularly validate the personal information we hold to ensure that the information is accurate and, where necessary, up to date. Information that is no longer required for any valid business purpose, and that we are not required to keep pursuant to any applicable law, will be routinely destroyed by secure means.</p>
      <h3>SUB-PROCESSORS</h3>
      <p>Below is a non-exhaustive list of our sub-processors and what they are used for. This list is subject to change:</p>
      <table border="1" cellspacing="1" cellpadding="1">
<tbody>
<tr>
<td>Sub-processor Name</td>
<td>Nature of Processing</td>
<td>Website</td>
</tr>
<tr>
<td>Amazon Web Services</td>
<td>Storage</td>
<td><strong><a title="https://aws.amazon.com/" href="https://aws.amazon.com/" target="_blank">https://aws.amazon.com/</a></strong></td>
</tr>
<tr>
<td>Heroku</td>
<td>Web Application Hosting</td>
<td><strong><a title="https://www.heroku.com/" href="https://www.heroku.com/" target="_blank">https://www.heroku.com/</a></strong></td>
</tr>
<tr>
<td>Adestra</td>
<td>Email Marketing Provider</td>
<td><strong><a title="https://www.adestra.com/" href="https://www.adestra.com/" target="_blank">https://www.adestra.com/</a></strong></td>
</tr>
<tr>
<td>Salesforce</td>
<td>CRM Provider</td>
<td><strong><a title="https://www.salesforce.com/uk/" href="https://www.salesforce.com/uk/" target="_blank">https://www.salesforce.com/uk/</a></strong></td>
</tr>
<tr>
<td>Exavault</td>
<td>Secure File Transfer</td>
<td><strong><a title="https://www.exavault.com/privacy/" href="https://www.exavault.com/privacy/" target="_blank">https://www.exavault.com/privacy/</a></strong></td>
</tr>
</tbody>
</table>


      </b-col>
  </b-row>
  </b-container>


</template>

<script>
    export default {
        name: "PrivacyPolicy.vue"
    }
</script>

<style scoped>
  p {
    font-size: small;
  }
  li {
    font-size: small;
  }

  h3 {
    font-size: large;
    margin-bottom: 1rem;
    margin-top: 1rem;
  }
  h5{
    font-size: medium;
    margin-bottom: 0.75rem;
    margin-top: 0.75rem;
  }



</style>



// WEBPACK FOOTER //
// src/components/PrivacyPolicy.vue